<template>
  <div class="multiple-language-wrapper">
    <div
      class="flex select-multiple-language items-center cursor-pointer"
      ref="sortby-select-wrapper"
      @click="handleOpenDropdown()"
    >
      <img src="@/assets/images/icon/icon-multiple-language.svg" class="mr-1" alt="">
      {{ presenterLocale }}
    </div>
    <aha-context-menu
      ref="context-menu-sort"
      full-width
      @hide="handleHideDropdown()"
      class="list-language"
    >
      <ul>
        <li
          class="context-menu-item"
          v-for="(option, optionIndex) in languageOptions"
          :key="optionIndex"
          @click="selectLanguage(option)"
        >
          {{ option.name }}
        </li>
      </ul>
    </aha-context-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import constants from '@/constant'
import util from '@/util'

export default {
  data() {
    return {
      languageOptions: constants.languageOptions,
      languageSelected: {},
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presenterLocale: (state) => state.presenterLocale,
    }),
  },
  mounted() {
    this.initLanguage()
  },
  methods: {
    ...mapActions(['setSelectedSortCriteriaAction', 'patchCurrentUserAction']),
    initLanguage() {
      try {
        const languageCode = window.localStorage.getItem('ahaslides-presenter-language')
        if (languageCode) {
          const index = this.languageOptions.findIndex((item) => item.language === languageCode)
          if (index !== -1) {
            this.languageSelected = constants.languageOptions[index]
          }
        }
      } catch (error) {
        Sentry.captureException(error)
      }

      if (!this.languageSelected.language) {
        // eslint-disable-next-line prefer-destructuring
        this.languageSelected = this.languageOptions[0]
      }
    },
    handleOpenDropdown() {
      this.$refs['context-menu-sort'].show()
      this.$refs['sortby-select-wrapper'].classList.add('active')
      let category = constants.eventCategories.PRESENTATION_LIST
      if (this.$route.name === 'Login') {
        category = constants.eventCategories.PRESENTER_LOGIN
      } else if (this.$route.name === 'Register') {
        category = constants.eventCategories.PRESENTER_REGISTER
      }
      const eventAction = 'Header > language > Open'
      const trackData = {
        eventAction,
        eventCategory: category,
        eventLabel: null,
        currentLanguage: this.presenterLocale,
        userId: this.currentUser.id,
      }
      util.trackGA4AndMixpanel(eventAction, trackData)
    },
    handleHideDropdown() {
      this.$refs['sortby-select-wrapper'].classList.remove('active')
    },
    async selectLanguage(item) {
      const oldLang = this.presenterLocale
      this.languageSelected = item
      this.$store.dispatch('setPresenterLang', item.language)
      if (this.currentUser.id) {
        this.currentUser.personalInformation = this.currentUser.personalInformation || {}
        const payload = {
          personalInformation: this.currentUser.personalInformation,
        }
        payload.personalInformation.presenterLanguage = item.language
        await this.patchCurrentUserAction({
          userId: this.currentUser.id,
          ...payload,
        })
      }
      window.localStorage.setItem('ahaslides-presenter-language', item.language)
      this.$store.state.presenterLanguageSelected = item.language

      let category = constants.eventCategories.PRESENTATION_LIST
      if (this.$route.name === 'Login') {
        category = constants.eventCategories.PRESENTER_LOGIN
      } else if (this.$route.name === 'Register') {
        category = constants.eventCategories.PRESENTER_REGISTER
      }
      const eventAction = 'Header > language > Select language'
      const trackData = {
        eventAction,
        eventCategory: category,
        eventLabel: item.language,
        currentLanguage: oldLang,
        userId: this.currentUser.id,
      }
      util.trackGA4AndMixpanel(eventAction, trackData)
    },
  },
}
</script>

<style lang="scss" scoped>
.list-language {
  right: 30px;
  top: -8px;
  &::v-deep {
    .context-menu-wrapper {
      min-width: 0;
    }
    .w-full {
      width: auto;
    }
  }
}
.multiple-language-wrapper {
  position: absolute;
  top: 33px;
  right: 0;
  .select-multiple-language {
    padding: 10px;
    border-radius: 20px;
    transition: ease-in-out 0.25s;
    font-weight: bold;
    text-transform: uppercase;
    color: #282e3e;
    cursor: pointer;
    &:hover, &.active {
      background-color: #EFF1F7;
    }

    .fa-chevron-down {
      display: block;
    }
    .fa-chevron-up {
      display: none;
    }

    &.active {
      .fa-chevron-down {
        display: none;
      }
      .fa-chevron-up {
        display: block;
      }
    }
  }
}
</style>
